import { ICopiaProcessoAuditoriaUseCase } from "../../../presentation/useCases/create/copia_processo_auditoria_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class CopiaProcessoAuditoriaUseCase implements ICopiaProcessoAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async copiaProcessoAuditoria(
    IdProcesso: number,
    IdAuditoria: number,
    Descricao: string | null,
    IdFuncionario: number | null,
    DescResponsavel: string | null,
    ResponsavelCadastrado: boolean | null,
    Data: Date | null,
    Horario: string | null,
    RequisitoNormativo: string | null,
    Local: number | null,
  ): Promise<void> {
    await this.repository.copiaProcessoAuditoria(
      IdProcesso,
      IdAuditoria,
      Descricao,
      IdFuncionario,
      DescResponsavel,
      ResponsavelCadastrado,
      Data,
      Horario,
      RequisitoNormativo,
      Local,
    );
  }
}
